function showApplyForm() {
    document.getElementById("apply-form").open();
    document.getElementById("text_info").close();
}

function showTextInfo() {
    document.getElementById("text_info").open();
    document.getElementById("apply-form").close();
}

if (document.getElementById("apply-button")) {
    button = document.getElementById("apply-button");
    button.addEventListener("click", showApplyForm, true);
}

if (document.getElementById("text-button")) {
    button = document.getElementById("text-button");
    button.addEventListener("click", showTextInfo, true);
}
